import useSWR, { SWRConfiguration } from "swr";
import { axios_server } from "../backend";

const fetcher = async (URL: string) => {
  try {
    const res = await axios_server.get(URL);
    return res.data;
  } catch (error: any) {
    console.log("FETCHER ERROR", error);
    //throw error?.response || error;
  }
};

const useFetch = (URL?: string | null, configuration?: SWRConfiguration) =>
  useSWR(URL, fetcher, configuration);

export default useFetch;
